<template>
    <v-container>
        <v-row  align="center" justify="center">
            <v-col cols="12" xs="12" sm="10" md="5">
                <v-form  ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                    <v-card class="pt-5" raised>
                        <v-card-title>Reset Password</v-card-title>
                       <v-container class="px-5">
                           <v-row>
                               <v-col cols="12">
                                   <v-text-field
                                       v-model="email"
                                       :rules="emailRules"
                                       label="E-mail"
                                       required
                                       :error-messages="errorMessage"
                                       @input="errorMessage = undefined"
                                   ></v-text-field>
                               </v-col>
                           </v-row>
                           <v-card-actions>
                               <v-btn color="primary" block  @click="submit">Invia link per il reset</v-btn>
                           </v-card-actions>
                       </v-container>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Login",
        data: () => ({
            valid: false,
            email: undefined,
            emailRules: [
                v => !!v || 'Email è obbligatoria',
                v => /.+@.+/.test(v) || 'Inserire un’e-mail valida',
            ],
            errorMessage:undefined
        }),
        methods: {
            submit () {
                if (this.$refs.form.validate()) {
                    axios.get("/password/reset",{
                      params: {
                        email: this.email
                      }
                      }).then( response => {
                      // console.log("password reset response", response.data)
                        this.$router.replace("/login")
                    }).catch(error => {
                      console.log("errore!:",error)
                        if(error.response)
                        switch (error.response.status) {

                            case 401:
                                this.errorMessage = "E-mail non verificata";
                                break;
                            case 404:
                            default :
                                this.errorMessage = "E-mail non valida";
                                break;
                        }
                        else {
                            this.errorMessage = error.toString()
                        }
                    })
                }
            },
        },
    }
</script>

<style scoped>

</style>
